import React from 'react';
import { ButtonGroup as FlowBiteButtonGroup, ButtonGroupProps as FlowBiteButtonGroupProps } from 'flowbite-react';
import { buttonGroupTheme } from '../../styles/themes/buttonGroup';
export type ButtonGroupProps = FlowBiteButtonGroupProps & {
    ariaLabel?: string;
    testId?: string;
    children: React.ReactNode;
};

export const ButtonGroup: React.FC<ButtonGroupProps> = ({ testId, ariaLabel, children }) => {
    return (
        <FlowBiteButtonGroup data-testid={testId} aria-label={ariaLabel} theme={buttonGroupTheme}>
            {children}
        </FlowBiteButtonGroup>
    );
};
